import { DAILY_QUEST_UPDATED, type DailyQuestState, type QuestSlot } from "@core/economy/dailyQuestRules";
import { trackDailyQuestRpc } from "../data-access/dailyQuestSupabase";
import { showQuestCompleteToast } from "../lib/toast";

/**
 * ⚠ N-41 (2026-07-30): 모바일에서 `login` 슬롯을 기록하는 코드가 **0건**이었다.
 *   그래서 모바일만 쓰는 사용자는 추천·기여를 다 해도 서버의 slot_login이 false로 남아
 *   3슬롯 완주와 +30 EXP를 영원히 받을 수 없었다(웹에만 배선돼 있었다).
 *
 * 세션이 확정되는 시점에 하루 한 번 기록한다. RPC 자체는 멱등이지만
 * (UPDATE로 true 설정) 앱 포커스·토큰 갱신마다 부르면 낭비라 로컬로 하루 1회로 막는다.
 *
 * 🔑 마킹 키에 **user id와 KST 날짜**를 넣는다 —
 *   user를 빼면 계정 전환 시 다른 계정의 마킹 때문에 기록이 누락된다(N-40과 같은 함정).
 */
const LOGIN_MARK_PREFIX = 'sotda-daily-quest-login';

/** KST 기준 오늘 (서버 track_daily_quest와 같은 경계) */
function kstToday(): string {
  return new Date(Date.now() + 9 * 3600_000).toISOString().slice(0, 10);
}

export async function markLoginQuestOnce(userId: string | null | undefined): Promise<void> {
  if (!userId) return;
  const key = `${LOGIN_MARK_PREFIX}:${userId}:${kstToday()}`;
  try {
    if (localStorage.getItem(key)) return;
  } catch {
    // 저장소를 못 쓰면 매번 호출한다 — 멱등이라 안전하다
  }
  const state = await trackDailyQuest('login');
  // 실패(오프라인·미인증)면 마킹하지 않는다 → 다음 기회에 다시 시도한다
  if (!state) return;
  try {
    localStorage.setItem(key, '1');
  } catch { /* 저장 실패는 무시 — 다음에 한 번 더 부를 뿐이다 */ }
}

export async function trackDailyQuest(slot: QuestSlot): Promise<DailyQuestState | null> {
  const state = await trackDailyQuestRpc(slot);
  if (!state) return null;
  if (state.completed_bonus_granted) showQuestCompleteToast();
  if (typeof window !== "undefined") window.dispatchEvent(new CustomEvent(DAILY_QUEST_UPDATED, { detail: state }));
  return state;
}
